export default __webpack_public_path__ + "static/media/Mobile.b1fb8592.jpg";